'use client'

import React, { useState } from 'react'
import Image from 'next/image'

const HeaderFinal = () => {
  // Estado SIMPLE y CONFIRMADO que funciona
  const [menuOpen, setMenuOpen] = useState(false)
  
  console.log('🔧 HeaderFinal - Estado:', menuOpen ? 'ABIERTO' : 'CERRADO')

  const menuItems = [
    { label: 'Inicio', href: '/' },
    { label: 'Cumpleaños', href: '/cumpleanos' },
    { label: 'Aniversario', href: '/aniversarios' },
    { label: 'Propuesta', href: '/propuesta' },
    { label: 'La Vida es Hoy', href: '/lavidaeshoy' },
    { label: 'Vuelos Grupales', href: '/vuelos-grupales' },
    { label: 'Paquetes Combinados', href: '/paquetes-combinados' },
    { label: 'Alojamiento', href: '/opciones-alojamiento' },
    { label: 'Restaurante', href: '/restaurante' },
  ]

  // Función DIRECTA para alternar
  const toggleMenu = () => {
    console.log('🔧 Alternando menú de', menuOpen, 'a', !menuOpen)
    setMenuOpen(!menuOpen)
  }

  // Función DIRECTA para cerrar
  const closeMenu = () => {
    console.log('🔧 Cerrando menú')
    setMenuOpen(false)
  }

  return (
    <header className="sticky top-0 z-50 w-full border-b border-gray-800 bg-black">
      <div className="container mx-auto px-4">
        <div className="flex h-24 items-center justify-between">
          
          {/* Logo */}
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <Image
                src="/logo-footer.webp"
                alt="Airlovers Colombia - Parapente en los Andes"
                width={270}  // 50% más grande (180 × 1.5 = 270)
                height={90}  // 50% más grande (60 × 1.5 = 90)
                className="h-20 w-auto"  // Altura fija para adaptarse al header más alto
                priority
              />
            </div>
          </div>

          {/* Navegación Desktop */}
          <nav className="hidden md:flex items-center space-x-8">
            {menuItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-sm font-medium text-white hover:text-[#0EA5E9]"
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* Botones */}
          <div className="flex items-center gap-4">
            {/* Botón CTA */}
            <a
              href="https://wa.me/573028309637?text=¡Hola!%20Quiero%20reservar%20un%20vuelo%20en%20Airlovers"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full bg-[#059669] px-6 py-2.5 text-sm font-semibold text-white hover:bg-[#047857]"
            >
              RESERVAR
            </a>
            
            {/* Botón Hamburguesa Móvil */}
            <button 
              onClick={toggleMenu}
              className="md:hidden p-2 rounded-md text-white hover:text-[#0EA5E9] hover:bg-gray-800"
              type="button"
              aria-label={menuOpen ? "Cerrar menú" : "Abrir menú"}
            >
              {menuOpen ? (
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Menú Móvil */}
      {menuOpen && (
        <div className="md:hidden border-t border-gray-800 bg-black animate-in slide-in-from-top-2 duration-200">
          <div className="px-2 py-3 space-y-1">
            {menuItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={closeMenu}
                className="block px-3 py-3 rounded-md text-base font-medium text-white hover:text-[#0EA5E9] hover:bg-gray-800"
              >
                {item.label}
              </a>
            ))}
            
            {/* CTA móvil */}
            <div className="px-3 pt-4 border-t border-gray-100">
              <a
                href="https://wa.me/573028309637?text=¡Hola!%20Quiero%20reservar%20un%20vuelo%20en%20Airlovers"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMenu}
                className="block w-full text-center rounded-full bg-[#059669] px-6 py-3 text-base font-semibold text-white hover:bg-[#047857]"
              >
                RESERVAR MI VUELO
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  )
}

export default HeaderFinal